import React from 'react';
import { useUser } from '@/queries/useUser';
import { ProfileSection } from './profile/ProfileSection';
import { PasswordSection } from './profile/PasswordSection';
import { ExternalAnalyticsSection } from './profile/ExternalAnalyticsSection';
import { AddressSection } from './profile/AddressSection';
import { OtherSection } from './profile/OtherSection';
import { StanCard } from '@/components/core-components/StanCard/StanCard';
import { SUBSCRIPTION_TIERS } from '@/lib/api/subscriptions/types';

export const ProfileTab: React.FC = () => {
    const { user } = useUser();
    const isAffiliateOnlySubscription = user?.subscription_tier === SUBSCRIPTION_TIERS.AFFILIATE;

    return (
        <StanCard>
            <div className='w-full max-w-4xl space-y-10'>
                {/* Profile Information Section */}
                <ProfileSection />

                {/* Password Section */}
                <PasswordSection />

                {/* External Analytics Section - Only for non-affiliate users */}
                {!isAffiliateOnlySubscription && <ExternalAnalyticsSection />}

                {/* Address Section - Only for non-affiliate users */}
                {!isAffiliateOnlySubscription && <AddressSection />}

                {/* Other Section - Only for non-affiliate users */}
                {!isAffiliateOnlySubscription && <OtherSection />}
            </div>
        </StanCard>
    );
};

export default ProfileTab;
